function isJsonString(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if(typeof obj == 'object' && obj ){
                return true;
            }else{
                return false;
            }
        } catch(e) {
            // console.log('isJsonString error：'+str+'!!!'+e);
            return false;
        }
    }
    console.log('It is not a string!')
}

// 处理换行符
const handleWrap = value => {
  if (!value) return
  return value.replace(/\r|\n/g, '<br>')
}

const handleBold = text => {
  text = handleWrap(text)
  let r = ''
  if (!text) {
    return r
  }
  for (let i = 0; i < text.length; i++) {
    let t = text[i]
    if (t == '<') {
      let start = text.slice(i, i + 3)
      let end = text.slice(i, i + 4)
      if (start == "<b>") {
        r += "<span class='text-bold' style='font-weight: bold'>"
        i += 2
      } else if (end == "</b>") {
        r += "</span>"
        i += 3
      } else {
        r += t
      }
    } else {
      r += t
    }
  }
  // console.log('转义后的文字', r)
  return r
}

// 获取URL 中 Query
function GetQueryString(name) {
  console.log(name)
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 获取URL 中 hash
function getHashParameters() {
  var arr = (location.hash || "").replace(/^\#/, '').split("&");
  var params = {};
  for (var i = 0; i < arr.length; i++) {
    var data = arr[i].split("=");
    if (data.length == 2) {
      params[data[0]] = data[1];
    }
  }
  var channelIdObj
  Object.keys(params).forEach((item) => {
    if (item.indexOf('?')) {
      let getChannelId = item.split("?")[1]
      if (getChannelId == 'channelId') {
        channelIdObj = {
          channelId: params[item]
        }
      }
    }
  })
  params = Object.assign(params, channelIdObj)
  return params;
}


// 判断Object 是否为空
function isEmpObj(obj) {
  let t;
  for (t in obj) {
    return !1;
  }
  return !0;
};
// 获取scrollTop
function getScrollTop() {
  return document.body.scrollTop | document.documentElement.scrollTop;
}
/**
 *
 * @param dateObj 日期对象 Date Object
 * @param fmt 格式，字符串类型，YY代表年，MM代表月，DD代表日，hh时，mm分，ss秒，SS毫秒
 * @returns {*}
 */
function dateFormater(dateObj, fmt) {
  if (dateObj instanceof Date) {

  } else if (!(dateObj instanceof Date) && typeof (dateObj) == 'string') {
    dateObj = new Date(dateObj.replace(/-/g, '/'));
  } else {
    console.error('日期数据格式错误');
    return;
  }
  var o = {
    "M+": dateObj.getMonth() + 1, //月份
    "D+": dateObj.getDate(), //日
    "h+": dateObj.getHours(), //小时
    "m+": dateObj.getMinutes(), //分
    "s+": dateObj.getSeconds(), //秒
    "q+": Math.floor((dateObj.getMonth() + 3) / 3), //季度
    "S": dateObj.getMilliseconds() //毫秒
  };
  if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (dateObj.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

// 首页和详情页用的已测人数转换规则
function cutNum(num, leval = 4) {
  // 因为返回裁剪后的都是以万为单位，所以规定最少是10的4次幂;
  let standard = Math.pow(10, leval > 4 ? leval : 4);
  if (num > standard) {
    // 虽然level不同，但是最后返回的都要多少多少W人为单位
    return `${(num / 10000).toFixed(1)}W`
  } else {
    return num;
  }
}
// 依据产品需求计算停留时间
function countPVStayTime(enterTime, leaveTime) {
  let second = (leaveTime - enterTime) / 1000;
  let timeTxt = '';

  if (second < 30) {
    timeTxt = '<30s';
  } else if (second > 30 & second < 60) {
    timeTxt = '30s~1min';

  } else if (second > 60 & second < 180) {
    timeTxt = '1~3min';

  } else {
    timeTxt = '>3min';
  }
  return timeTxt;
}


function NumberAddZero(s, level) {
  level = level == undefined ? 1 : level;
  return (s * 1) < Math.pow(10, level) ? '0' + s : s;
};

// 测评报告页的维度数据，转换成eCharts图表格式的方法
function factorArrayToChart(factorArray) {
  let chartData = {
    data: [],
    pecent: [],
    label: [],
    resultName: [],
    level: [],
    max: [],
    min: [],
  };
  for (let i = 0; i < factorArray.length; i++) {
    let curFactor = factorArray[i];
    if (curFactor.actualScore != undefined) {
      chartData.data.push(curFactor.actualScore.toFixed(2));
    }
    if (curFactor.scoringRatio != undefined) {
      chartData.pecent.push(Math.round(curFactor.scoringRatio));
    }
    if (curFactor.factorName != undefined) {
      chartData.label.push(curFactor.factorName);
    }
    if (curFactor.resultName != undefined) {
      chartData.resultName.push(curFactor.resultName);
    }
    if (curFactor.level != undefined) {
      chartData.level.push(curFactor.level);
    }
    if (curFactor.referenceRange != undefined) {
      const min = curFactor.referenceRange.slice(0, curFactor.referenceRange.indexOf('-')) * 1;
      chartData.min.push(min.toFixed(2))
      const max = curFactor.referenceRange.slice(curFactor.referenceRange.lastIndexOf('-') + 1) * 1;
      chartData.max.push(max.toFixed(2))
    }
  }
  return chartData;
};


// PV统计
// PV统计，获取页面名称
function getPageName({
  router,
  useEnterFrom,
  enterFromRouter = {
    query: {}
  },
  fullTitle = false
}) {
  let zhugeIoVal = '';
  if (!router && !useEnterFrom) {
    zhugeIoVal = '直接访问';
  } else {
    // 页面没有的，需要用enterFrom 处理的
    if (useEnterFrom | (router && router.name == 'testDetail')) {
      if (!!enterFromRouter.query.enterFrom) {
        switch (enterFromRouter.query.enterFrom) {
          case 'shareImg':
            zhugeIoVal = '分享图';
            break;
          case 'shareMe':
            zhugeIoVal = '分享页_我也要测';
            break;
          case 'shareOther':
            zhugeIoVal = '分享页_大家都在测';
            break;
          case 'testDetail':
            zhugeIoVal = '测评详情页';
            break;
          case 'detail':
            zhugeIoVal = '支付完成';
            break;
          case 'readingReport':
            zhugeIoVal = '解读报告';
            break;
          case 'mine':
            zhugeIoVal = '我的测评';
            break;
          case 'reportCombo':
            zhugeIoVal = '套餐报告页';
            break;
          case 'notify':
            zhugeIoVal = '重复购买';
            break;
          case 'report2':
            zhugeIoVal = '报告';
            break;
          case 'banner':
            zhugeIoVal = 'banner图';
            break;
          default:
            zhugeIoVal = '其他';
        }
      } else {
        if (router) {
          zhugeIoVal = router.meta.title ? (typeof (router.meta.title) == 'function' ? router.meta.title.call(router) : router.meta.title) : (router.name == null ? '直接访问' : router.name);
        } else {
          zhugeIoVal = '直接访问'
        }
      }
    } else if (fullTitle & (typeof (router.meta.fullTitle) == 'function')) {
      zhugeIoVal = router.meta.fullTitle.call(router);
    } else {
      zhugeIoVal = router.meta.title ? (typeof (router.meta.title) == 'function' ? router.meta.title.call(router) : router.meta.title) : (router.name == null ? '直接访问' : router.name);
    }
  }
  return zhugeIoVal
};
/**
 *
 * @param Obj
 * Obj has 4 params
 * {to, from, enterTime, leaveTime}
 * to Page, vue-router Obj
 * from page, vue-router Obj,
 * enterTime, Date
 * leaveTime, Date
 */
function pageViewTracker({
  to,
  from,
  enterTime,
  leaveTime,
  addOn,
  isLeave
}) {
  console.log("pageViewTracker")
  /**
   *
   * @param router
   * @returns {{}}
   */
  function getQueryParams(router) {
    let otherOption = {};
    // 分类页的参数
    if (router.query.sort) {
      otherOption[`栏目`] = router.query.sort;
    }
    //跟踪标识全局添加
    if (router.query.sourceName) {
      otherOption[`跟踪标识`] = router.query.sourceName;
    }
    if (router.query.sortType) {
      const sortTypeMap = {
        [`1`]: `按热度`,
        [`2`]: `按时间`,
        [`3`]: `按价格`,
      }
      otherOption[`排序方式`] = sortTypeMap[router.query.sortType];
    }

    return otherOption;
  }

  function mergeOptions() {
    let obj1;
    if (!isLeave) {
      obj1 = Object.assign(getQueryParams(to), {
        [`访问时间`]: dateFormater(enterTime, 'YY/MM/DD hh:mm:ss'),
      });
    } else {
      obj1 = Object.assign(getQueryParams(to), {
        [`访问时间`]: dateFormater(enterTime, 'YY/MM/DD hh:mm:ss'),
        [`离开时间`]: dateFormater(leaveTime, 'YY/MM/DD hh:mm:ss'),
        [`浏览时长`]: countPVStayTime(enterTime, leaveTime)
      });
    }
    return Object.assign(obj1, addOn);
  }

  let fromPage = getPageName({
    router: from,
    useEnterFrom: true,
    enterFromRouter: to,
  });
  let toPage = getPageName({
    router: to,
    useEnterFrom: false
  });
  console.info(`从${fromPage}访问${toPage}`)
  // 同页面，不算PV, 测评详情页除外
  if ((to.name == (from ? from.name : '')) & (to.name != 'testDetail')) {
    return;
  }

  try {
    if (!to.meta.newZhugeTitle) {
      // 诸葛IO 统计
      if (!isLeave) {
        // 访问toPage，来自fromPage
        window.TRACKER.pageView(toPage, fromPage, mergeOptions());
      } else {
        // 离开 fromPage， 前往toPage
        window.TRACKER.pageLeave(fromPage, toPage, mergeOptions());
      }
    } else {
      if (isLeave) {
        window.TRACKER.newPageView(to.meta.newZhugeTitle, toPage, mergeOptions());
      }

    }

    //百度统计
    if (_hmt) {
      _hmt.push(['_trackPageview', location.pathname + '#' + to.path]);
    }
  } catch (err) {
    console.error(err);
  }
}

// lodash.pick的代替品
function pick(obj, keys) {
  return keys.reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {});
}

/**
 * 对多字节 emoji 进行转换 HTML 字符实体的处理
 * @param str
 * @returns {string|*}
 */
function utf16toEntities(str) {
  const patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
  str = String(str);
  str = str.replace(patt, function (char) {
    var H, L, code;
    if (char.length === 2) {
      H = char.charCodeAt(0); // 取出高位
      L = char.charCodeAt(1); // 取出低位
      code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法
      return "&#" + code + ";";
    } else {
      return char;
    }
  });
  return str;
}

function objToUrlParams(obj) {
  let paramsStr = '';
  for (let key in obj) {
    if ((typeof obj[key]).toLowerCase() !== 'object') {
      // 除去undefined
      if (obj[key] !== undefined) {
        paramsStr = paramsStr + `${key}=${obj[key]}&`;
      }
    } else if (obj[key] instanceof Array) {
      paramsStr = paramsStr + `${key}=${obj[key].join()}&`;
    } else {
      let temp = objToUrlParams(obj[key]);
      paramsStr = paramsStr + temp;
    }
  }
  // 移除最后的那个 & 符号
  return paramsStr.slice(0, paramsStr.length - 1);
}
/**
 * 将字符串内部的/n/r换成<br/>
 * @param str
 */
function changeLineToBr(str) {
  var reg = new RegExp("%0A", "g");

  str = escape(str).replace(reg, "%3Cbr/%3E");

  return str;
}
// 输入秒数，转换成 mm:ss的格式
function secondToTime(second) {
  let sec = NumberAddZero(Math.round(second) % 60, 1);
  let minute = NumberAddZero((second / 60).toFixed(0), 1);
  return `${minute}:${sec}`;
}


import store from '../store/store';
import dialog from '@/lib/dialog';
import '@/scss/dialog.scss';

function loadPageFail({
  pagename,
  err
}) {
  console.log("loadPageFail")
  window.monitor.stat({
    level: 'watch',
    error: 'File',
    msg: err.message,
    remark: `加载${pagename}失败`,
    userKey: store.state.userInfo.userKey,
  })
  var dialogData = {};
  dialogData.title = `抱歉，测评君开了小差`;
  dialogData.content = `加载${pagename}失败，检查网络并尝试刷新一下！`;
  dialogData.button = [{
    text: '好的',
    callback: 'del'
  }];
  dialog(dialogData);
}


function checkRichTextEmpty(richTextString) {
  let tempEl = document.createElement("div");
  tempEl.innerHTML = richTextString ? richTextString : '';
  if (tempEl.innerText.trim() == "") {
    return true
  } else {
    return false;
  }
}

function checkPhoneNumber(str) {
  var phone = parseInt(str);
  let pattern = /^\+?([0-9]+((\s?-?)|(-?\s?)))*$/;
  return pattern.test(phone);
}

function getPlatform() {
  var ua = navigator.userAgent, //获取浏览器UA
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isWechat = /(?:MicroMessenger)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isiPhone && !isAndroid && !isSymbian,
    isYixinliApp = /(?:yixinliApp)/.test(ua),
    isMamawanApp = /(?:PregnancyHelper)/.test(ua);
  return {
    isWechat: isWechat,
    isTablet: isTablet,
    isiPhone: isiPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isYixinliApp: isYixinliApp,
    isMamawanApp: isMamawanApp
  };
}

function checkPhone(val) {
  if (!(/^1(3|4|5|7|8|6|9)\d{9}$/.test(val))) {
    return false;
  }
  return true;
}

// 身份证号码验证
function IdentityCodeValid(code) {
  let city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  }
  let tip = ""
  let pass = true

  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    tip = "身份证号格式错误"
    pass = false
  } else if (!city[code.substr(0, 2)]) {
    tip = "地址编码错误"
    pass = false
  } else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split("")
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      //校验位
      var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      var last = parity[sum % 11]
      if (parity[sum % 11] != code[17]) {
        tip = "校验位错误"
        pass = false
      }
    }
  }
  return pass
}


/**
 * 设置/计算上下文值
 * @param  {}       context 上下文对象。
 * @param  {String} exp     字段表达式，以'.'和'[\d+]'分割成字段的访问堆栈
 * @param  {}       val     要设置的值，不传时为get。
 *
 * @example
 *  var data = {
 *      asd: {qwe: 123}
 *  };
 *
 *  parseExp(data, 'asd.qwe', 789);
 */
function parseExp(context, exp, val) {
  var chain = exp.replace(/^\[(\d+)\]/, '$1').replace(/\[(\d+)\]/g, '.$1').split('.'),
    last_key;

  if (arguments.length === 3) {
    last_key = chain.pop();
  }

  for (var i = 0; i < chain.length; i++) {
    if (!context) return;
    context = context[chain[i]];
  }

  if (last_key) {
    context[last_key] = val;
  } else {
    return context;
  }
}


//懒加载
function replaceAllImg(html) {
  var newContent = html.replace(/<img[^>]*>/gi, function (str, capture) {
    var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
    var url = str.match(srcReg);
    var mat = str.replace(/src=\"(.*)\"/gi, 'data-src=' + url[1]);
    return mat;
  });
  return newContent;
}

function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.onload = function() {
      script.onload = null;
      if (callback) callback();
  };

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

function copyText(vm, content, cb) {
  let selection = window.getSelection()
  let range = document.createRange()
  let $code = document.createElement('div')
  $code.display = 'none'
  $code.innerHTML = content
  document.body.appendChild($code)
  range.selectNodeContents($code)
  selection.removeAllRanges()
  selection.addRange(range)
  if (document.execCommand('copy')) {
      //浏览器是否支持复制
      document.execCommand('copy')
      if (cb) {
          cb()
      } else {
        vm.setTOASTTEXT('复制成功')
      }
  } else {
    vm.setTOASTTEXT('浏览器不支持复制功能')
  }
  selection = null
  range = null
  document.body.removeChild($code)
}


export {
  isJsonString,
  GetQueryString,
  factorArrayToChart,
  NumberAddZero,
  isEmpObj,
  pageViewTracker,
  getPageName,
  dateFormater,
  pick,
  cutNum,
  utf16toEntities,
  changeLineToBr,
  secondToTime,
  loadPageFail,
  checkRichTextEmpty,
  getPlatform,
  checkPhone,
  objToUrlParams,
  parseExp,
  IdentityCodeValid,
  getHashParameters,
  replaceAllImg,
  checkPhoneNumber,
  loadScript,
  copyText,
  handleWrap,
  handleBold,
};

export default {
  isJsonString,
  GetQueryString,
  isEmpObj,
  NumberAddZero,
  factorArrayToChart,
  pageViewTracker,
  getPageName,
  dateFormater,
  pick,
  cutNum,
  utf16toEntities,
  changeLineToBr,
  secondToTime,
  loadPageFail,
  checkRichTextEmpty,
  getPlatform,
  checkPhone,
  objToUrlParams,
  parseExp,
  IdentityCodeValid,
  getHashParameters,
  replaceAllImg,
  checkPhoneNumber,
  loadScript,
  handleWrap,
  handleBold,
}



// WEBPACK FOOTER //
// ./src/lib/units.js